import React, { useState, useEffect } from "react";
import { Box, Grid, Typography, Divider, FormControl, Select, MenuItem } from "@material-ui/core";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import { Helmet } from "react-helmet";

import { useNavigate } from "react-router-dom";
import CurrencyFormat from "react-currency-format";

import { FreeShippingBanner } from "./styles";

function DetailsTxt({ product, ringSizes, handleAddToCart }) {
  const [ringSizeRequired, setRingSizeRequired] = useState(false);

  //const classes = useStyles();
  const navigate = useNavigate();

  useEffect(() => {
    if (product?.Category?.includes("Rings")) {
      setRingSizeRequired(true);
    } else {
      setRingSizeRequired(false);
    }

    if (!product) {
      navigate("/");
    }
  }, [product, navigate]);

  const handleAskForProduct = () => {
    navigate("/cart/AskForProduct");
  };

  const handleAddToCartClick = () => {
    handleAddToCart(product.ProductId, 1);
    navigate("/cart");
  };

  const handleViewCart = () => {
    navigate("/cart");
  };

  const productDetails = [
    { label: "SKU", value: product.SKU },
    { label: "DESIGNER", value: product.Designer },
    { label: "METAL", value: product.MetalDescription },
    { label: "GEMSTONE", value: product.GemstoneName },
    { label: "SIZE", value: product.Size },
    { label: "LENGTH", value: product.LengthDescription },
    { label: "PEARL TYPE", value: product.PearlType },
    { label: "PEARL SIZE", value: product.PearlSize },
    { label: "PRODUCT ERA", value: product.EraDescription },
    { label: "PRODUCT COMMENTS", value: product.Comments }
  ];

  return (
    <Box>
      <Helmet>
        <title>{product.ProductName}</title>
        <meta name="description" content={product.Description} />
      </Helmet>
      <Grid container spacing={2} margin={2}>
        <Grid item xs={12}>
          <Box height="100%" display="flex" flexDirection="column">
            <FreeShippingBanner>
              <Typography variant="h5">Free shipping available in Canada</Typography>
            </FreeShippingBanner>

            <Typography gutterBottom variant="h5" component="h2">
              {product.ProductName}
            </Typography>

            <Typography dangerouslySetInnerHTML={{ __html: product.Description }} variant="h6" color="textSecondary" component="p" />
            <Divider />

            <div hidden={!ringSizeRequired}>
              <Stack direction="row" spacing={2}>
                <Typography variant="h6">Select Ring Size</Typography>
                <FormControl xs={{ m: 1, minWidth: 120 }} size="small">
                  <Select variant="standard" autoWidth labelId="ringSize-select-label" id="ringSize-select" value={product.ringSizeId} label="Ring Size">
                    <MenuItem disabled value="">
                      <em>Please Select</em>
                    </MenuItem>
                    {ringSizes.map((item) => (
                      <MenuItem value={item.RingSizeId} key={item.RingSizeId}>
                        {item.RingSize}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <Typography variant="h6" color="textPrimary">
                  Required
                </Typography>
              </Stack>
            </div>

            <Grid container spacing={2}>
              <Grid item xs={12} sm={4} md={4}>
                <Typography gutterBottom variant="body1" component="h2">
                  <CurrencyFormat value={product.Price} displayType={"text"} thousandSeparator prefix={"$ "} />
                </Typography>
              </Grid>

              <Grid item xs={12} sm={12} md={4}>
                <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                  <Button variant="contained" color="success" fullWidth onClick={handleAskForProduct}>
                    REQUEST BY EMAIL
                  </Button>
                  <Button variant="contained" color="primary" fullWidth onClick={handleAddToCartClick}>
                    ADD TO CART
                  </Button>
                  <Button variant="outlined" color="secondary" fullWidth onClick={handleViewCart}>
                    VIEW CART
                  </Button>
                </div>
              </Grid>

              <Grid item xs={12} sm={4} md={4} alignItems="flex-end" sx={{ display: "flex", justifyContent: "flex-end" }}>
                <Typography
                  gutterBottom
                  variant="body1"
                  component="h2"
                  align="right"
                  sx={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    fontSize: { xs: "1rem", sm: "1.2rem", md: "1.5rem" },
                    width: { xs: "100%", sm: "auto" }, // Ensure it's full width on small screens
                    maxWidth: "100%" // Prevents overflow
                  }}
                >
                  IN STOCK
                </Typography>
              </Grid>
            </Grid>

            <Divider />
            <Typography gutterBottom variant="h5" component="h2">
              Product Details
            </Typography>
            <Divider />

            {productDetails.map(
              ({ label, value }, index) =>
                value && (
                  <div key={index}>
                    <Typography variant="body1">
                      {label}: {value}
                    </Typography>
                    <Divider />
                  </div>
                )
            )}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

export default DetailsTxt;
